import { render } from "./PokemonInfo.vue?vue&type=template&id=0857f01a&scoped=true"
import script from "./PokemonInfo.vue?vue&type=script&lang=ts"
export * from "./PokemonInfo.vue?vue&type=script&lang=ts"

import "./PokemonInfo.vue?vue&type=style&index=0&id=0857f01a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0857f01a"

export default script